import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const savePageCount = (_, { payload }) => {
  return {
    pageCount: payload
  }
};

const clearPageCount = () => {
  return initialState
}

const initialState = {
  pageCount: 0
};

export default createReducer(initialState, {
  [TYPES.SERVICE_REQUEST_PAGE_COUNT]: savePageCount,
  [TYPES.CLEAR_PAGE_COUNT]: clearPageCount,
});
